var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ disabled: _vm.disabled }},[_c('v-btn',{attrs:{"elevation":"2","icon":""}},[_c('v-icon',{attrs:{"color":"primary"},on:{"click":_vm.toggleShowColumnChooser}},[_vm._v("mdi-table-column-width")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }